export default __webpack_public_path__ + "static/media/logo-icon.28cb6726.png";